<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="" prop="venderFid">
      <el-input v-model="dataForm.venderFid" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="venderinviteFid">
      <el-input v-model="dataForm.venderinviteFid" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="enterprisenature">
      <el-input v-model="dataForm.enterprisenature" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="venturepartner">
      <el-input v-model="dataForm.venturepartner" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="address">
      <el-input v-model="dataForm.address" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="postcode">
      <el-input v-model="dataForm.postcode" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="creditcode">
      <el-input v-model="dataForm.creditcode" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="technician">
      <el-input v-model="dataForm.technician" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="operator">
      <el-input v-model="dataForm.operator" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="qccontroller">
      <el-input v-model="dataForm.qccontroller" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="trialproduce">
      <el-input v-model="dataForm.trialproduce" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="totalnum">
      <el-input v-model="dataForm.totalnum" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="areacovered">
      <el-input v-model="dataForm.areacovered" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="productionarea">
      <el-input v-model="dataForm.productionarea" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="buildarea">
      <el-input v-model="dataForm.buildarea" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="ppeOriginalvalue">
      <el-input v-model="dataForm.ppeOriginalvalue" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="peePresentvalue">
      <el-input v-model="dataForm.peePresentvalue" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="laOriginalvalue">
      <el-input v-model="dataForm.laOriginalvalue" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="fluidfund">
      <el-input v-model="dataForm.fluidfund" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="legalperson">
      <el-input v-model="dataForm.legalperson" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="salesrevenueLastyear">
      <el-input v-model="dataForm.salesrevenueLastyear" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="totalassetsLastyear">
      <el-input v-model="dataForm.totalassetsLastyear" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="latotalLastyear">
      <el-input v-model="dataForm.latotalLastyear" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="salesrevenueThisyear">
      <el-input v-model="dataForm.salesrevenueThisyear" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="totalassetsThisyear">
      <el-input v-model="dataForm.totalassetsThisyear" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="latotalThisyear">
      <el-input v-model="dataForm.latotalThisyear" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="taxnum">
      <el-input v-model="dataForm.taxnum" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="venderType">
      <el-input v-model="dataForm.venderType" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="bankname">
      <el-input v-model="dataForm.bankname" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="fax">
      <el-input v-model="dataForm.fax" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="accountname">
      <el-input v-model="dataForm.accountname" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="accountnum">
      <el-input v-model="dataForm.accountnum" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="draftnum">
      <el-input v-model="dataForm.draftnum" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="bankaddress">
      <el-input v-model="dataForm.bankaddress" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="paynum">
      <el-input v-model="dataForm.paynum" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="venderIntroduce">
      <el-input v-model="dataForm.venderIntroduce" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="createdBy">
      <el-input v-model="dataForm.createdBy" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="createDate">
      <el-input v-model="dataForm.createDate" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="updatedBy">
      <el-input v-model="dataForm.updatedBy" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="updateDate">
      <el-input v-model="dataForm.updateDate" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="deletedBy">
      <el-input v-model="dataForm.deletedBy" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="deleteDate">
      <el-input v-model="dataForm.deleteDate" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="isDeleted">
      <el-input v-model="dataForm.isDeleted" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="remark">
      <el-input v-model="dataForm.remark" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="optCounter">
      <el-input v-model="dataForm.optCounter" placeholder=""></el-input>
    </el-form-item>
    <el-form-item label="" prop="auxilarea">
      <el-input v-model="dataForm.auxilarea" placeholder=""></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          venderbaseinfoId: 0,
          venderFid: '',
          venderinviteFid: '',
          enterprisenature: '',
          venturepartner: '',
          address: '',
          postcode: '',
          creditcode: '',
          technician: '',
          operator: '',
          qccontroller: '',
          trialproduce: '',
          totalnum: '',
          areacovered: '',
          productionarea: '',
          buildarea: '',
          ppeOriginalvalue: '',
          peePresentvalue: '',
          laOriginalvalue: '',
          fluidfund: '',
          legalperson: '',
          salesrevenueLastyear: '',
          totalassetsLastyear: '',
          latotalLastyear: '',
          salesrevenueThisyear: '',
          totalassetsThisyear: '',
          latotalThisyear: '',
          taxnum: '',
          venderType: '',
          bankname: '',
          fax: '',
          accountname: '',
          accountnum: '',
          draftnum: '',
          bankaddress: '',
          paynum: '',
          venderIntroduce: '',
          createdBy: '',
          createDate: '',
          updatedBy: '',
          updateDate: '',
          deletedBy: '',
          deleteDate: '',
          isDeleted: '',
          remark: '',
          optCounter: '',
          auxilarea: ''
        },
        dataRule: {
          venderFid: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          venderinviteFid: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          enterprisenature: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          venturepartner: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          postcode: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          creditcode: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          technician: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          operator: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          qccontroller: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          trialproduce: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          totalnum: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          areacovered: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          productionarea: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          buildarea: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          ppeOriginalvalue: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          peePresentvalue: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          laOriginalvalue: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          fluidfund: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          legalperson: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          salesrevenueLastyear: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          totalassetsLastyear: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          latotalLastyear: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          salesrevenueThisyear: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          totalassetsThisyear: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          latotalThisyear: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          taxnum: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          venderType: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          bankname: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          fax: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          accountname: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          accountnum: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          draftnum: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          bankaddress: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          paynum: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          venderIntroduce: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          createdBy: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          createDate: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          updatedBy: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          updateDate: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          deletedBy: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          deleteDate: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          isDeleted: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          remark: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          optCounter: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          auxilarea: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.venderbaseinfoId = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.venderbaseinfoId) {
            this.$http({
              url: this.$http.adornUrl(`/venderbasicinfo/tvenderbasicinfo/info/${this.dataForm.venderbaseinfoId}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.venderFid = data.tvenderbasicinfo.venderFid
                this.dataForm.venderinviteFid = data.tvenderbasicinfo.venderinviteFid
                this.dataForm.enterprisenature = data.tvenderbasicinfo.enterprisenature
                this.dataForm.venturepartner = data.tvenderbasicinfo.venturepartner
                this.dataForm.address = data.tvenderbasicinfo.address
                this.dataForm.postcode = data.tvenderbasicinfo.postcode
                this.dataForm.creditcode = data.tvenderbasicinfo.creditcode
                this.dataForm.technician = data.tvenderbasicinfo.technician
                this.dataForm.operator = data.tvenderbasicinfo.operator
                this.dataForm.qccontroller = data.tvenderbasicinfo.qccontroller
                this.dataForm.trialproduce = data.tvenderbasicinfo.trialproduce
                this.dataForm.totalnum = data.tvenderbasicinfo.totalnum
                this.dataForm.areacovered = data.tvenderbasicinfo.areacovered
                this.dataForm.productionarea = data.tvenderbasicinfo.productionarea
                this.dataForm.buildarea = data.tvenderbasicinfo.buildarea
                this.dataForm.ppeOriginalvalue = data.tvenderbasicinfo.ppeOriginalvalue
                this.dataForm.peePresentvalue = data.tvenderbasicinfo.peePresentvalue
                this.dataForm.laOriginalvalue = data.tvenderbasicinfo.laOriginalvalue
                this.dataForm.fluidfund = data.tvenderbasicinfo.fluidfund
                this.dataForm.legalperson = data.tvenderbasicinfo.legalperson
                this.dataForm.salesrevenueLastyear = data.tvenderbasicinfo.salesrevenueLastyear
                this.dataForm.totalassetsLastyear = data.tvenderbasicinfo.totalassetsLastyear
                this.dataForm.latotalLastyear = data.tvenderbasicinfo.latotalLastyear
                this.dataForm.salesrevenueThisyear = data.tvenderbasicinfo.salesrevenueThisyear
                this.dataForm.totalassetsThisyear = data.tvenderbasicinfo.totalassetsThisyear
                this.dataForm.latotalThisyear = data.tvenderbasicinfo.latotalThisyear
                this.dataForm.taxnum = data.tvenderbasicinfo.taxnum
                this.dataForm.venderType = data.tvenderbasicinfo.venderType
                this.dataForm.bankname = data.tvenderbasicinfo.bankname
                this.dataForm.fax = data.tvenderbasicinfo.fax
                this.dataForm.accountname = data.tvenderbasicinfo.accountname
                this.dataForm.accountnum = data.tvenderbasicinfo.accountnum
                this.dataForm.draftnum = data.tvenderbasicinfo.draftnum
                this.dataForm.bankaddress = data.tvenderbasicinfo.bankaddress
                this.dataForm.paynum = data.tvenderbasicinfo.paynum
                this.dataForm.venderIntroduce = data.tvenderbasicinfo.venderIntroduce
                this.dataForm.createdBy = data.tvenderbasicinfo.createdBy
                this.dataForm.createDate = data.tvenderbasicinfo.createDate
                this.dataForm.updatedBy = data.tvenderbasicinfo.updatedBy
                this.dataForm.updateDate = data.tvenderbasicinfo.updateDate
                this.dataForm.deletedBy = data.tvenderbasicinfo.deletedBy
                this.dataForm.deleteDate = data.tvenderbasicinfo.deleteDate
                this.dataForm.isDeleted = data.tvenderbasicinfo.isDeleted
                this.dataForm.remark = data.tvenderbasicinfo.remark
                this.dataForm.optCounter = data.tvenderbasicinfo.optCounter
                this.dataForm.auxilarea = data.tvenderbasicinfo.auxilarea
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/venderbasicinfo/tvenderbasicinfo/${!this.dataForm.venderbaseinfoId ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'venderbaseinfoId': this.dataForm.venderbaseinfoId || undefined,
                'venderFid': this.dataForm.venderFid,
                'venderinviteFid': this.dataForm.venderinviteFid,
                'enterprisenature': this.dataForm.enterprisenature,
                'venturepartner': this.dataForm.venturepartner,
                'address': this.dataForm.address,
                'postcode': this.dataForm.postcode,
                'creditcode': this.dataForm.creditcode,
                'technician': this.dataForm.technician,
                'operator': this.dataForm.operator,
                'qccontroller': this.dataForm.qccontroller,
                'trialproduce': this.dataForm.trialproduce,
                'totalnum': this.dataForm.totalnum,
                'areacovered': this.dataForm.areacovered,
                'productionarea': this.dataForm.productionarea,
                'buildarea': this.dataForm.buildarea,
                'ppeOriginalvalue': this.dataForm.ppeOriginalvalue,
                'peePresentvalue': this.dataForm.peePresentvalue,
                'laOriginalvalue': this.dataForm.laOriginalvalue,
                'fluidfund': this.dataForm.fluidfund,
                'legalperson': this.dataForm.legalperson,
                'salesrevenueLastyear': this.dataForm.salesrevenueLastyear,
                'totalassetsLastyear': this.dataForm.totalassetsLastyear,
                'latotalLastyear': this.dataForm.latotalLastyear,
                'salesrevenueThisyear': this.dataForm.salesrevenueThisyear,
                'totalassetsThisyear': this.dataForm.totalassetsThisyear,
                'latotalThisyear': this.dataForm.latotalThisyear,
                'taxnum': this.dataForm.taxnum,
                'venderType': this.dataForm.venderType,
                'bankname': this.dataForm.bankname,
                'fax': this.dataForm.fax,
                'accountname': this.dataForm.accountname,
                'accountnum': this.dataForm.accountnum,
                'draftnum': this.dataForm.draftnum,
                'bankaddress': this.dataForm.bankaddress,
                'paynum': this.dataForm.paynum,
                'venderIntroduce': this.dataForm.venderIntroduce,
                'createdBy': this.dataForm.createdBy,
                'createDate': this.dataForm.createDate,
                'updatedBy': this.dataForm.updatedBy,
                'updateDate': this.dataForm.updateDate,
                'deletedBy': this.dataForm.deletedBy,
                'deleteDate': this.dataForm.deleteDate,
                'isDeleted': this.dataForm.isDeleted,
                'remark': this.dataForm.remark,
                'optCounter': this.dataForm.optCounter,
                'auxilarea': this.dataForm.auxilarea
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
